import { get } from '../../../utils/get';
export var getCurrentLanguage = function (item) { return get(item, 'context.currLangCode'); };
